import { render } from "./ComponenteInputPrecios.vue?vue&type=template&id=8b25efaa"
import script from "./ComponenteInputPrecios.vue?vue&type=script&lang=js"
export * from "./ComponenteInputPrecios.vue?vue&type=script&lang=js"

import "./ComponenteInputPrecios.vue?vue&type=style&index=0&id=8b25efaa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__